// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';
import uuidv4 from 'uuid/v4';

import styles from './styles';

class Helper extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    reverse: PropTypes.bool,
  };

  static defaultProps = {
    classes: {},
    image: null,
    title: 'title',
    description: 'description',
    reverse: false,
  };

  render() {
    const {
      classes,
      image,
      title,
      description,
      reverse,
    } = this.props;

    return (
      <div className={classNames(classes.mainContainer,
        reverse ? classes.noReverse : classes.reverse,
        reverse ? classes.leftType : classes.rightType)}
      >
        <div className={classes.imageContainer}>
          <img className={classes.image} src={image} alt={'helper'} />
        </div>
        <div className={classes.descriptionContainer}>
          <h1 className={classes.title}>{title}</h1>
          <span key={uuidv4()} className={classes.description}>{description}</span>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Helper);
